import { FC } from 'react';
import classNames from 'classnames';
import loadingSpinner from '../../../img/loading-spinner.gif';

interface Props {
    loading?: boolean;
}

const LoadingOverlay: FC<Props> = ({ loading = false }) => {
    const loadingOverlayClasses = classNames('loading-background', {
        ready: !loading
    });

    return (
        <div className={loadingOverlayClasses} data-testid="LoadingOverlay">
            <img src={loadingSpinner} />
        </div>
    );
};

export default LoadingOverlay;
